import React from 'react';
import {View, ScrollView} from 'react-native';

import sy from '~/styles';
import {Text, Dialog} from '~/components/controls';
import Format from '~/lib/format';
import {ROB_ERROR_TRANSLATIONS} from '~/types/rob';

import ErrorIcon from '~/images/md-icons/error/materialicons/24px.svg';
import PropTypes from 'prop-types';

const RobRequestErrorsDialog = ({onDismiss, robErrors}) => (
  <Dialog
    visible={true}
    title="Fout werkopdracht"
    buttons={[
      {
        text: 'OK',
        onPress: onDismiss,
      },
    ]}>
    <ScrollView contentContainerStyle={{maxHeight: 400}}>
      {robErrors
        .filter((item) => !item.task_id)
        .map((item) => (
          <View
            style={[sy['flex-row'], sy['py-4']]}
            key={`${item.code}-${item.error}-${
              item.other_service_request?.licensePlate ?? 'none'
            }`}>
            <View style={[{flexShrink: 0}, sy['pr-4']]}>
              <ErrorIcon height="24px" width="24px" fill="#972727" />
            </View>
            <View style={[sy['flex-1'], sy['gap-4']]}>
              <Text>{ROB_ERROR_TRANSLATIONS[item.code] ?? item.error}</Text>
              {item.other_service_request?.licensePlate && (
                <View>
                  <Text>Blokkerende opdracht:</Text>
                  <Text>
                    {Format.license(item.other_service_request.licensePlate)}
                  </Text>
                </View>
              )}
              <Text style={[sy.small, sy['text-lightgray']]}>{item.code}</Text>
            </View>
          </View>
        ))}
    </ScrollView>
  </Dialog>
);
RobRequestErrorsDialog.propTypes = {
  onDismiss: PropTypes.any,
  robErrors: PropTypes.any,
};

export default RobRequestErrorsDialog;
